module.exports = {"410772400":"小店工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410772.json
// module id = 1593
// module chunks = 0